import React, {FC, memo} from 'react';
import {INewsGridProps} from '@common/types';
import {getCardClassNames} from '@common/functions';
import NewsCard from '@modules/News/components/NewsCard';


const NewsGrid: FC<INewsGridProps> = ({news}) => {
  return (
    <div className="news-content__list news">
      <ul className="news__list">
        {news.map((n, index) => {
          const classNames = [
            'news-card__picture',
            ...getCardClassNames(n.cardType || null, 'news-card__picture')
          ]
          const withLink = n.case || n.url || null
          return (
            <NewsCard
              key={`news_card_${n.title}_${index}`}
              item={n}
              classNames={classNames}
              withLink={withLink}
            />
          )
        })}
      </ul>
    </div>
  )
}

export default memo(NewsGrid)
